import React from 'react'
import parse from 'html-react-parser'
import Figure from './Figure'
import { FragmentProps } from '../../../interfaces/Publication'
import { usePublication } from '../../../hooks/usePublication'


const REFERENCIA = ({ fragment }: FragmentProps) => {

    const { path } = usePublication()

    return (
        <div className='htmlReview' style={{ marginBottom: "20px" }}>

            <div className='p-container gcontent'>
                {fragment.text ? parse(fragment.text) : null}
            </div>
        </div>

    )
}

export default REFERENCIA